import React from 'react'
import Classes from '../Information.module.css'

export default function Authorization({ handleFinish, handleBack, formData, setFormData }) {
  const handleChange = (e) => {
    setFormData({ ...formData, authorizationSignature: e.target.value });
  };

  return (
    <>
      <div className={Classes.infoCon} >
        <div>
          <h3>Authorization</h3>
        </div>
        <div className={Classes.infoConMiddle} >
          <div className={Classes.textInstructions} >
            <h5 className={`${Classes.textBold} mb-10`} style={{ fontSize: '13px' }} >Some data brokers will require proof of your relationship with privacyBot before they will honor removal requests.</h5>
            <div className={Classes.formText} >
              <h5 className={Classes.text} >
                I, {formData.firstName} {formData.lastName}, grant privacyNow, LLC, and its partners (“privacyNow”) authority to act as my authorized agent for the purposes of performing the privacyNow service.
                <br />
                <br />
                This Limited Power of Attorney is granted only to the extent necessary for privacyNow to submit requests under the California Consumer Privacy
                Act, General Data Protection Regulation, Australian Privacy Act, or other relevant privacy legislation (the “Privacy Laws”), to any organization
                governed by the Privacy Laws, which grants consumers certain rights to request access to personal information (as defined in the Privacy Laws), to
                obtain copies of the personal information, to request the deletion of the personal information, and to opt-out of the sale of the personal information.
                <br />
                <br />
                Authorized actions may include (without limiting the generality of the foregoing) contacting third parties, such as data brokers, aggregators or
                other parties who have control over this content, signing opt-out requests, and any other action privacyBot reasonably deems necessary to remove,
                suppress, or opt-out my personal information from unwanted sources and any other actions taken in fulfillment of my services order as stated in
                privacyBot’s Terms of Service. PrivacyBot shall have no liability for actions taken under this letter so long as it acts reasonably.
                <br />
                <br />
                This authorization will remain in full force and effect until I cancel my privacyBot service.
              </h5>
            </div>
          </div>
          <div className={Classes.flexColGroup} style={{ marginTop: '2rem' }} >
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Signature (optional)</h5>
              <input
                type='text'
                value={formData.authorizationSignature}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='Sign here'
              />
            </div>
            <div className={Classes.flexCol1} ></div>
            <div className={Classes.flexCol1} ></div>
          </div>
        </div>
        <div>
          <div className={Classes.flexEnd} >
            <div className={Classes.flexAlign10} >
              <button className={Classes.backBtn} onClick={handleBack} > <h5>Back</h5> </button>
              <button className={Classes.nextBtn} onClick={handleFinish} > <h5>Finish</h5> </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}